import Image from "components/Image"
import getImageDimensions from "utilities/getImageDimensions"
import richText from "utilities/richText"

export default function CampaignShowcase({ blok }) {
  return (
    <div className="relative">
      <div className='before:content-[" "] before:absolute before:rounded-4xl before:w-full before:h-full before:bg-warm-white/70 before:mix-blend-overlay before:border-2 border-solid before:border-white'>
        <div className="flex flex-col lg:flex-row relative items-center gap-6 lg:gap-8 p-6">
          <div className="lg:w-1/2 prose">
            <Image
              height={getImageDimensions("height", blok.image.filename)}
              width={getImageDimensions("width", blok.image.filename)}
              src={blok.image.filename}
              alt={blok.image.alt}
            />
          </div>
          <div className="lg:w-1/2">
            {blok.heading && <h3 className="tracking-wider uppercase mb-2">{blok.heading}</h3>}
            <div className="prose text-white">{richText(blok.content)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
